<template>
    <div class="filters_buttons">
        <button type="button" class="filters__clear" @click="onClearFiltersMobile" v-show="!selectedFilters.length == 0" :disabled="selectedFilters.length == 0">CLEAR FILTERS</button>
        <button type="button" class="filters__viewresults" @click="closeFiltersPanel()">VIEW RESULTS</button>
    </div>
</template>
<script>
export default {
    name: "filtersButtonBlock",
    props: ["filter", "selectedFilters"],
    data(){
        return {
        }
    },
    watch: {
    },
    methods: {
        closeFiltersPanel(){
            this.$emit("viewResults");
        },
        onClearFiltersMobile(){
            this.$emit("clearFilters");
        }
    }
};
</script>
